module.exports = __webpack_public_path__ + "fb-tutorial-3-en.png?624a71ef52da1557dfadde1e26631f93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-3-en.png
// module id = //x6
// module chunks = 50